import React from 'react'
import style from "../ProjectMap/ProjectMap.module.scss";

export default function PlaceSvg( {
    handleDescriptionClick,
    description,
    top,
    left,
    activeIndex,
    setActiveIndex,
    id
} ) {

    const handleSvgClick = () => {
        setActiveIndex((prevActiveIndex) => (prevActiveIndex === id ? null : id));
    };

    return (
        <>
            <div style={{position: 'absolute', top: `${top}%`, left: `${left}%`}}>
                <div className={`${style.placeContainer}`}>
                    <svg onClick={handleSvgClick}
                         className={style.placeSvg}
                         xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 60 60" fill="none">
                        <path
                            d="M51.55 21.125C48.925 9.575 38.85 4.375 30 4.375C30 4.375 30 4.375 29.975 4.375C21.15 4.375 11.05 9.55 8.42499 21.1C5.49999 34 13.4 44.925 20.55 51.8C23.2 54.35 26.6 55.625 30 55.625C33.4 55.625 36.8 54.35 39.425 51.8C46.575 44.925 54.475 34.025 51.55 21.125ZM30 33.65C25.65 33.65 22.125 30.125 22.125 25.775C22.125 21.425 25.65 17.9 30 17.9C34.35 17.9 37.875 21.425 37.875 25.775C37.875 30.125 34.35 33.65 30 33.65Z"
                            fill={`${activeIndex === id ? '#fff' : '#D11018'}`}/>
                    </svg>
                    {activeIndex === id && (
                        <div onClick={handleDescriptionClick}
                             className={`${style.description} ${style.desktop} ${activeIndex ? style.active : ''}`}>
                            <p>{description}</p>
                        </div>
                    )}
                </div>
            </div>
            {activeIndex === id && (
                <div onClick={handleDescriptionClick}
                     className={`${style.description} ${style.mobile} ${activeIndex ? style.active : ''}`}>
                    <p>{description}</p>
                </div>
            )}
        </>
    )
}
